module.exports = __webpack_public_path__ + "img/8.47c14220.png";